import { useApiGetQuery, useApiMutation } from 'utils/queryClient'

export const usersQueryKey = ['users']
export const userQueryKey = id => ['users', String(id)]

const useUsers = (options = {}) =>
  useApiGetQuery({
    defaultValue: [],
    endpoint: '/users',
    queryKey: usersQueryKey,
    options,
  })

export const useUpdateUser = (options = {}) =>
  useApiMutation(({ id }) => `/users/${id}`, 'patch', options)

export const useDeleteUser = (options = {}) =>
  useApiMutation(({ id }) => `/users/${id}`, 'delete', options)

export const useUser = (id, options = {}) =>
  useApiGetQuery({
    defaultValue: null,
    endpoint: `/users/${id}`,
    queryKey: userQueryKey(id),
    options: {
      enabled: Boolean(id) && id !== 'new',
      ...options,
    },
  })

export const useCreateUser = (options = {}) =>
  useApiMutation('/users', 'post', options)

export default useUsers
